import elementoVisivel from '../dom';

const FORM = '[data-tour="recursos-form-consideracao"]';
const DESFECHO = '[data-tour="recursos-form-consideracao-desfecho"]';
const FUNDAMENTACAO = '[data-tour="recursos-form-consideracao-fundamentacao"]';
const UPLOAD = '[data-tour="recursos-form-consideracao-upload"]';
const ENVIAR = '[data-tour="recursos-enviar-consideracao"]';

export default {
  id: 'recursos-form-consideracao',
  kind: 'tour',
  version: 1,
  label: 'Juízo de consideração',
  contexts: ['auction.recursos'],
  scopes: ['form-consideracao'],
  priority: 30,
  help: true,
  canQueue(ctx = {}) {
    return Boolean(ctx.logged && ctx.podeConsiderar);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.formVisible) return false;
    if (ctx.podeConsiderar === false) return false;
    return Boolean(elementoVisivel(FORM));
  },
  steps() {
    const steps = [
      {
        element: FORM,
        popover: {
          title: 'Juízo de consideração',
          description:
            'Como pregoeiro, use este formulário para considerar o recurso na janela de consideração/julgamento.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    if (elementoVisivel(DESFECHO)) {
      steps.push({
        element: DESFECHO,
        popover: {
          title: 'Consideração',
          description: 'Selecione o desfecho da consideração (Deferido ou Indeferido).',
          side: 'bottom',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(FUNDAMENTACAO)) {
      steps.push({
        element: FUNDAMENTACAO,
        popover: {
          title: 'Fundamentação',
          description:
            'Justifique a consideração. A fundamentação é obrigatória e permanente após o envio.',
          side: 'top',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(UPLOAD)) {
      steps.push({
        element: UPLOAD,
        popover: {
          title: 'Anexos',
          description: 'Inclua anexos que embasem a consideração, se necessário.',
          side: 'left',
          align: 'start',
        },
      });
    }

    if (elementoVisivel(ENVIAR)) {
      steps.push({
        element: ENVIAR,
        popover: {
          title: 'Enviar Consideração',
          description:
            'Confirme e envie. Após o envio, a consideração não pode ser editada ou excluída por aqui.',
          side: 'top',
          align: 'start',
        },
      });
    }

    return steps;
  },
};
